export default "__VITE_ASSET__DlQFGQLf__"